import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02556ff9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "recreation" }
const _hoisted_4 = { class: "recreation-list clearfix" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["data-clipboard-text"]
const _hoisted_9 = {
  key: 0,
  class: "chance"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tm_rule_popup = _resolveComponent("tm-rule-popup")!
  const _component_tm_login_popup = _resolveComponent("tm-login-popup")!
  const _component_tm_receive_success_popup = _resolveComponent("tm-receive-success-popup")!
  const _component_tm_receive_red_packet_popup = _resolveComponent("tm-receive-red-packet-popup")!
  const _component_tm_forward_popup = _resolveComponent("tm-forward-popup")!

  return (_ctx.gameInfo.displaySwitch)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("ul", {
                class: "recreation-item",
                style: _normalizeStyle({ transform: 'translateY(' + _ctx.y1 + 'vw)' })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prizeList1, (prize, key) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "recreation-prices",
                    key: key
                  }, [
                    _createElementVNode("img", {
                      class: _normalizeClass([{ 'subsidy-icon': key === 3 }]),
                      src: prize.img,
                      alt: ""
                    }, null, 10, _hoisted_5)
                  ]))
                }), 128))
              ], 4),
              _createElementVNode("ul", {
                class: "recreation-item",
                style: _normalizeStyle({ transform: 'translateY(' + _ctx.y2 + 'vw)' })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prizeList2, (prize, key) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "recreation-prices",
                    key: key
                  }, [
                    _createElementVNode("img", {
                      class: _normalizeClass([{ 'subsidy-icon': key === 3 }]),
                      src: prize.img,
                      alt: ""
                    }, null, 10, _hoisted_6)
                  ]))
                }), 128))
              ], 4),
              _createElementVNode("ul", {
                class: "recreation-item",
                style: _normalizeStyle({ transform: 'translateY(' + _ctx.y3 + 'vw)' })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prizeList3, (prize, key) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "recreation-prices",
                    key: key
                  }, [
                    _createElementVNode("img", {
                      class: _normalizeClass([{ 'subsidy-icon': key === 3 }]),
                      src: prize.img,
                      alt: ""
                    }, null, 10, _hoisted_7)
                  ]))
                }), 128))
              ], 4)
            ]),
            _createElementVNode("div", {
              class: "rule-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleTmRulePopup({ isShowTmRulePopup: true })))
            }),
            _createElementVNode("div", {
              class: "draw-btn",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDrawLottery && _ctx.handleDrawLottery(...args)))
            }),
            _createElementVNode("div", {
              class: "forward-btn",
              "data-clipboard-text": _ctx.shareCon,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleForward && _ctx.handleForward(...args)))
            }, null, 8, _hoisted_8),
            (_ctx.gameLoginStatus)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 今日剩余次数：" + _toDisplayString(_ctx.gameInfo.remainPlayCount), 1))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "chance",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDrawLottery && _ctx.handleDrawLottery(...args)))
                }, "请登录"))
          ])
        ]),
        _createVNode(_component_tm_rule_popup, {
          gameRule: _ctx.gameInfo.gameRule,
          isShowTmRulePopup: _ctx.isShowTmRulePopup,
          onToggleTmRulePopup: _ctx.toggleTmRulePopup
        }, null, 8, ["gameRule", "isShowTmRulePopup", "onToggleTmRulePopup"]),
        _createVNode(_component_tm_login_popup, {
          isShowTmLoginPopup: _ctx.isShowTmLoginPopup,
          onToggleTmLoginPopup: _ctx.toggleTmLoginPopup
        }, null, 8, ["isShowTmLoginPopup", "onToggleTmLoginPopup"]),
        _createVNode(_component_tm_receive_success_popup, {
          isShowTmReceiveSuccessPopup: _ctx.isShowTmReceiveSuccessPopup,
          onToggleTmReceiveSuccessPopup: _ctx.toggleTmReceiveSuccessPopup
        }, null, 8, ["isShowTmReceiveSuccessPopup", "onToggleTmReceiveSuccessPopup"]),
        _createVNode(_component_tm_receive_red_packet_popup, {
          lotteryResultBO: _ctx.lotteryResultBO,
          isShowReceiveRedPacketPopup: _ctx.isShowReceiveRedPacketPopup,
          onToggleTmReceiveRedPacketPopup: _ctx.toggleTmReceiveRedPacketPopup,
          onToggleTmReceiveSuccessPopup: _ctx.toggleTmReceiveSuccessPopup
        }, null, 8, ["lotteryResultBO", "isShowReceiveRedPacketPopup", "onToggleTmReceiveRedPacketPopup", "onToggleTmReceiveSuccessPopup"]),
        _createVNode(_component_tm_forward_popup, {
          isShowTmForWardPopup: _ctx.isShowTmForWardPopup,
          onToggleTmForWardPopup: _ctx.toggleTmForWardPopup
        }, null, 8, ["isShowTmForWardPopup", "onToggleTmForWardPopup"])
      ]))
    : _createCommentVNode("", true)
}